import styled from 'styled-components'

export const StyledBackgroundImage = styled.div`
  width: 100%;
  background-image: url('${({ src }) => src}');
  height: 75px;
  border-bottom-left-radius: 0.688rem;
  border-bottom-right-radius: 0.688rem;
`

export const TieredInterventionShutterList = styled.div`
  width: 100%;
  padding: 0 1.25rem;
  align-items: center;
  justify-content: center;
  max-width: 1366px;

  .tiered-intervention-shutter-list {
    /* The contentDescription (tiered intervention callout) is the first child */
    & > div:first-child {
      margin-bottom: -1.5rem;
    }

    /* The items are subsequent divs */
    & > div:not(:first-child) {
      margin-top: 0;
    }
  }
`
